module.exports = __webpack_public_path__ + "videos/animatie_worm_op.mp4";